import { parsePhoneNumberFromString } from 'libphonenumber-js';

const DEFAULT_COUNTRY = 'US';

export const parseUsPhoneNumber = (value) => {
  if (!value) {
    return null;
  }

  return parsePhoneNumberFromString(String(value), DEFAULT_COUNTRY) || null;
};

export const isValidUsPhoneNumber = (value) => {
  const parsedPhoneNumber = parseUsPhoneNumber(value);
  return Boolean(parsedPhoneNumber?.isValid() && parsedPhoneNumber.country === DEFAULT_COUNTRY);
};

export const toUsE164PhoneNumber = (value) => {
  const parsedPhoneNumber = parseUsPhoneNumber(value);
  if (!parsedPhoneNumber?.isValid() || parsedPhoneNumber.country !== DEFAULT_COUNTRY) {
    return null;
  }

  return parsedPhoneNumber.number;
};

export const toUsNationalPhoneNumber = (value) => {
  const parsedPhoneNumber = parseUsPhoneNumber(value);
  if (!parsedPhoneNumber?.isValid() || parsedPhoneNumber.country !== DEFAULT_COUNTRY) {
    return null;
  }

  return String(parsedPhoneNumber.nationalNumber);
};

export const normalizeRideUberPhoneNumbers = (stepOneValues = {}) => {
  const riderSourcePhoneNumber =
    stepOneValues?.riderDraft?.phoneNumber || stepOneValues?.riderInfo?.phoneNumber;
  const riderPhoneNumber = toUsNationalPhoneNumber(riderSourcePhoneNumber);
  if (!riderPhoneNumber) {
    return { isValid: false, value: stepOneValues };
  }

  const riderDraftPhoneNumber = stepOneValues?.riderDraft?.phoneNumber
    ? toUsNationalPhoneNumber(stepOneValues?.riderDraft?.phoneNumber)
    : null;

  if (stepOneValues?.riderDraft?.phoneNumber && !riderDraftPhoneNumber) {
    return { isValid: false, value: stepOneValues };
  }

  const caregivers = Array.isArray(stepOneValues?.caregivers) ? stepOneValues.caregivers : [];
  const normalizedCaregivers = caregivers.map((caregiver) => {
    const caregiverPhoneNumber = toUsNationalPhoneNumber(caregiver?.phoneNumber);
    if (!caregiverPhoneNumber) {
      return null;
    }

    return {
      ...caregiver,
      phoneNumber: caregiverPhoneNumber,
    };
  });

  if (normalizedCaregivers.some((caregiver) => caregiver === null)) {
    return { isValid: false, value: stepOneValues };
  }

  const hasRiderInfoObject =
    Boolean(stepOneValues?.riderInfo) && typeof stepOneValues.riderInfo === 'object';

  return {
    isValid: true,
    value: {
      ...stepOneValues,
      ...(hasRiderInfoObject
        ? {
            riderInfo: {
              ...stepOneValues.riderInfo,
              phoneNumber: riderPhoneNumber,
            },
          }
        : {}),
      ...(stepOneValues?.riderDraft
        ? {
            riderDraft: {
              ...stepOneValues.riderDraft,
              phoneNumber: riderDraftPhoneNumber,
            },
          }
        : {}),
      caregivers: normalizedCaregivers,
    },
  };
};
